import type { Overview } from '@manaro/contracts'
import { Card } from '@/shared/ui/card.tsx'
import { formatCompact, formatValue } from '@/shared/lib/format.ts'

export function LoadCard({ load }: { load: Overview['load'] }) {
  const numbers = [
    { value: formatCompact(load.bookings), label: 'записей клиентов' },
    { value: formatCompact(load.workingSalons), label: 'салонов работали' },
    { value: formatCompact(load.newCustomers), label: 'новых клиентов' },
  ]

  const facts = [
    `Завершено ${formatCompact(load.completed)}`,
    `отмены ${formatValue(load.cancelRate, 'percent')}`,
    `напоминаний ${formatCompact(load.reminders)}`,
    load.deliveryRate !== null ? `доставка ${formatValue(load.deliveryRate, 'percent')}` : null,
    load.smsSpent > 0 ? `SMS ${formatCompact(load.smsSpent)}` : null,
  ].filter((fact): fact is string => fact !== null)

  return (
    <Card className="flex min-w-0 flex-col gap-3.5 px-5.5 py-5">
      <h2 className="font-display text-[17px] font-semibold">Нагрузка платформы</h2>

      <div className="flex flex-wrap gap-5">
        {numbers.map((item) => (
          <div key={item.label}>
            <div className="tabular font-display text-[26px] leading-none font-semibold">{item.value}</div>
            <div className="mt-1.5 text-[12.5px] text-ink-muted">{item.label}</div>
          </div>
        ))}
      </div>

      <p className="rounded-control border border-line-soft bg-canvas px-3.5 py-3 text-[13.5px] text-ink-soft text-balance-pretty">
        {facts.join(' · ')}
      </p>
    </Card>
  )
}
